import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
export function getCachedFlagValueKey(flag) {
    return `pplx.${flag}.eppo_cache`;
}
export function readCachedFlagValue(cacheKey, defaultValue) {
    const storedValue = SafeLocalStorage.getItem(cacheKey);
    if (storedValue === null)
        return defaultValue;
    try {
        return JSON.parse(storedValue);
    }
    catch {
        return defaultValue;
    }
}
//# sourceMappingURL=cachedFlagValue.js.map